import _ from 'lodash';
import React, {Component} from 'react';
import { connect } from 'react-redux';
import StripeCheckout from 'react-stripe-checkout';
import {STRIPE_PUBLISHABLE_KEY,COMMON_FAIL_MESSAGE,HIGHEND_PASSWORD} from 'Constants';
import {StripeProvider,Elements} from 'react-stripe-elements';
import CheckoutForm from './checkoutform.js';

class StripeCheckoutForm extends Component{
  constructor(props){
    super(props);
  }
  render(){
    return(
      <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
        <Elements>
          <CheckoutForm amount={this.props.amount} email={this.props.email} onTokenReceived={this.props.onTokenReceived}/>
        </Elements>
      </StripeProvider>
    )
  }
}
export default StripeCheckoutForm;
